import React, { FC } from 'react';
import Icon from '../icon';
import { TCarouselArrowProps } from './types/carouselArrow.types';

const CarouselArrow: FC<TCarouselArrowProps> = ({ direction, onClick, onClickSecondary, className, additionalCssClass = '' }: TCarouselArrowProps) => {
  const icon = `arrow-chevron-${direction === 'previous' ? 'left' : 'right'}` as 'arrow-chevron-left' | 'arrow-chevron-right';
  return (
    <button
      className={`carousel-arrow carousel-arrow--${direction === 'previous' ? 'left' : 'right'}
       ${className !== '' ? className : ''} ${additionalCssClass}`}
      aria-label={`${direction}slide / item`}
      type="button"
      onClick={() => {
        onClick && onClick();
        onClickSecondary && onClickSecondary();
      }}
    >
      <Icon iconName={icon} color="complement" size={30} extraClassName={'carousel-arrow__icon'} />
    </button>
  );
};

export default CarouselArrow;
